import { ApiError } from './api';
import { SESSION_PROTOCOL_VERSION } from './session-core';

export type ModerationAction =
  | 'suspend_24h' | 'suspend_7d' | 'ban' | 'restore'
  | 'disable_matchmaking' | 'enable_matchmaking' | 'disable_challenges' | 'enable_challenges'
  | 'resolve_report' | 'dismiss_report';

export interface ModerationReport {
  id: string; reason: string; status: string; contextType: 'pair' | 'group' | 'say_it'; createdAt: string;
  target: {
    userId: string; firstName: string; accountStatus: 'active' | 'suspended' | 'banned'; suspendedUntil: string | null;
    moderationStatus: 'clear' | 'reviewing' | 'actioned'; matchmakingEnabled: boolean; challengeEnabled: boolean;
  };
}

const headers = (initData: string): Record<string, string> => ({
  Accept: 'application/json', Authorization: `tma ${initData}`, 'Content-Type': 'application/json',
  'X-UTAGE-Protocol': String(SESSION_PROTOCOL_VERSION)
});

export const loadModerationReports = async (initData: string): Promise<ModerationReport[]> => {
  const response = await fetch('/safety/moderation/reports', { cache: 'no-store', headers: headers(initData) });
  const body = await response.json().catch(() => ({})) as { reports?: ModerationReport[]; error?: { message?: string; code?: string } };
  if (!response.ok || !body.reports) throw new ApiError(body.error?.message ?? 'Could not load moderation.', body.error?.code);
  return body.reports;
};

export const moderateReport = async (
  initData: string, report: ModerationReport, action: ModerationAction
): Promise<ModerationReport> => {
  const response = await fetch('/safety/moderation/actions', {
    method: 'POST', headers: headers(initData),
    body: JSON.stringify({ actionId: crypto.randomUUID(), reportId: report.id, targetUserId: report.target.userId, action })
  });
  const body = await response.json().catch(() => ({})) as ModerationReport & { error?: { message?: string; code?: string } };
  if (!response.ok || !body.id) throw new ApiError(body.error?.message ?? 'Could not save moderation.', body.error?.code);
  return body;
};
